import { atomWithStorage } from "jotai/utils";

export const debugModeAtom = atomWithStorage<boolean>("debugMode", false);
